export const getEditProjectPage = (id: string) => `/projects/edit/${id}`;
// link for feed page
export const getFeedPage = (type: string) => `/feed?type=${type}`;

// link for team page
export const getTeamProfileLink = (teamId: string) => `/teams/${teamId}`;

// link for page to create new challenge page
export const getCreateChallengeLink = () => "/challenges/create-challenge";

// link for page to view all challenges
export const getChallengesLink = () => "/challenges";

// link for page to view details page
export const getChallengeDetailsLink = (id: string) =>
  `/challenges/details/${id}`;

// link for editor page to create project
export const getCreateProjectLink = () => "/projects/create";

// link for project full page view
export const getProjectFullPageUrl = (id: string) => `/project/full-page/${id}`;

/**
 * Link for project details page
 * @param id project id
 * @param comment comment id (optional)
 * @returns url to project page. If comment id is passed
 * it will be added as a query param
 */
export const getProjectDetailsPageUrl = (id: string, comment?: string) =>
  comment
    ? `/project/details/${id}?comment=${comment}`
    : `/project/details/${id}`;

/**
 * Link for project details page
 * @param id project id
 * @param comment comment id (optional)
 * @returns url to project page. If comment id is passed
 * it will be added as a query param
 */
export const getTeamProjectDetailsPageUrl = (id: string, comment?: string) =>
  comment
    ? `/team-project/details/${id}?comment=${comment}`
    : `/team-project/details/${id}`;

// URLs for team
export const getCreateTeamURL = () => `/teams/create`;

// URLS for team projects
export const getEditTeamProjectUrl = (teamId: string, projectId: string) =>
  `/team-projects/${teamId}/${projectId}/edit`;

// URLs for auth
export const getLoginUrl = () => `/login`;
export const getSignUpUrl = () => `/sign-up`;

// URLs for editing user profile
export const getEditProfileCoverURL = () => `/projects/profile/edit?active=0`;
export const getEditProfileBaseURL = () => `/projects/profile/edit?active=1`;
export const getEditProfileAboutURL = () => `/projects/profile/edit?active=2`;
export const getEditProfileInterestsURL = () =>
  `/projects/profile/edit?active=3`;

// URLs for profile
export const getProfileURL = (userId: string) => `/user/${userId}`;
export const getProfileProjectsURL = (userId: string) =>
  `/user/${userId}/projects`;
export const getProfileLikedProjectsURL = (userId: string) =>
  `/user/${userId}/liked-projects`;

// URLS for search
export const getProfileSearchURL = (search: string) => `/search/?q=${search}`;

// URLs for user tutorials
export const getBannerTutorialURL = () => `/tutorials/profile-banner`;
export const getTutorialProfileBackgroundURL = () =>
  `/tutorials/profile-background`;
export const getTutorialProfileAboutURL = () => `/tutorials/profile-about`;
export const getTutorialProfileInterestsURL = () =>
  `/tutorials/profile-interests`;
// export const getUserProfileTeamsLinkBase = (id: string) => `/user/${id}/teams`;
// export const getUserProfileTeamInvitationsLink = (id: string) =>
//   `/user/${id}/team-invitations`;
// link for user team page
// export const getUserProfileTeamsLink = (id: string, filter = "your-teams") =>
//   `/user/${id}/teams?t=${filter}`;
